import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import LaunchWorkflowRunSourceTranscription from '@Application/WorkflowRuns/Sources/Commands/LaunchWorkflowRunSourceTranscription';
import launchWorkflowRunSourceTranscription from '@Application/WorkflowRuns/Sources/launchWorkflowRunSourceTranscription';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import useStrictCurrentFacility from '@UI/Providers/CurrentFacilityProvider/useStrictCurrentFacility';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly subject: SubjectAddress;
	readonly preparationId: number;
	readonly elementId: number;
};

/** « Lancer la transcription » on an element the server says can be transcribed. Leaf action component. */
const LaunchTranscriptionButton: React.FC<Props> = ({ subject, preparationId, elementId }) => {
	const dispatch = useDispatch();
	const { currentFacility } = useStrictCurrentFacility();
	const facilityId = currentFacility.id;
	const [isLaunching, setIsLaunching] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setIsLaunching(true);
		dispatch(
			launchWorkflowRunSourceTranscription(
				new LaunchWorkflowRunSourceTranscription(facilityId, subject, preparationId, elementId),
			),
		)
			.catch(ignoreHandledError)
			.finally(() => {
				setIsLaunching(false);
			});
	}, [dispatch, facilityId, subject, preparationId, elementId]);

	return (
		<Button
			type="button"
			size="sm"
			severity="secondary"
			label="Lancer la transcription"
			loading={isLaunching}
			onClick={handleClick}
		/>
	);
};

export default LaunchTranscriptionButton;
